module.exports = __webpack_public_path__ + "static/media/kogx-logo.572aea24.svg";